import { render } from "./search-2.vue?vue&type=template&id=5f77d19a&scoped=true"
import script from "./search-2.vue?vue&type=script&lang=js"
export * from "./search-2.vue?vue&type=script&lang=js"

import "./search-2.vue?vue&type=style&index=0&id=5f77d19a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f77d19a"]])

export default __exports__